import React from "react";
import { HeaderProps } from "./Header.types";
import { getClassName } from "../../helpers/common.helpers";
import { renderLeftContainerUI, renderRightContainerUI } from "./header.helpers";

import "./HeaderComponent.scss";

const HeaderComponent = ({ headerClass = "", headerLeftContainerClass = "", headerRightContainerClass = "", companyName = "", companyLogoPath = "", customLeftContainerChildren, homeNavigate = false, taxYear = "", contactInfoChildren, accountInfoChildren, customRightContainerChildren, onHomeClick }: HeaderProps) => {
    return (
        <header className={getClassName("tp-header", headerClass)}>
            <div className={getClassName("tp-header__left-container", headerLeftContainerClass)}>
                {renderLeftContainerUI(companyName, companyLogoPath, customLeftContainerChildren)}
            </div>
            <div className={getClassName("tp-header__right-container", headerRightContainerClass)}>
                {renderRightContainerUI(homeNavigate, taxYear, contactInfoChildren, accountInfoChildren, customRightContainerChildren, onHomeClick!)}
            </div>
        </header>
    )
}

export default HeaderComponent;